import React, {Component} from "react";
import pkg from '../../../package.json';
import Property from "../../components/About/";
import Device from './../../devices/device';
import RequestManager from './../../requests/RequestManager';
import "../../components/About/About.css";

const VERSION = 0;
const RELEASE = 1;
const IP = 2;
let APK = 3;

class About extends Component{
	constructor(props){
		super(props);		
		this.state = {
			ip: '0.0.0.0',
		};
		this.properties = [{name: 'Versión:',
						 value: pkg.version},
						 {name: 'Release:',
						 value: ''},
						 {name: 'IP:',
						 value: ''}
		]
	}

	getCommit = () =>{
		let collection = document.body.getElementsByTagName("script");
		let elems = Array.from(collection);
		let commit = "NA";
		let src = "";
		elems.map(elem => {
			src = elem.src;
			if(src.includes("main.")){
				commit = src.substring(src.indexOf("main.")+5, src.indexOf(".js"));
			}
		});
		this.properties[RELEASE].value = commit;
	}

	getIP = () =>{
		var request = new XMLHttpRequest();
		request.open('GET', 'http://api.ipify.org', true);
		let that = this;
		request.onload = function () {
		  if (request.status >= 200 && request.status < 400) {
		  	that.properties[IP].value = this.response;
		  	that.forceUpdate();
		  } else {
		    console.log('error');
		  }
		}

		request.send();
	}

	getApk = () =>{
		if(Device.getDevice().getPlatform() === 'android'){
			let userAgent = navigator.userAgent;
			let apkStringArray = userAgent.trim().split(" ");
			this.properties.push({name:'Versión de APK', value: parseInt(apkStringArray[apkStringArray.length-1])});
		}
	}

	componentDidUpdate(){
		this.properties[IP].value = this.state.ip;
	}

	componentWillMount(){
   		this.getCommit();
   		this.getIP();
   		this.getApk();
	}


	render(){
	    return (
	      <div className="settings"> 
	      	<div className="settings-about">
	      		<h1>Acerca de esta versión</h1>
	      		<Property properties={ this.properties }/>
	      	</div>
	      </div>
	    )
	  }
}

export default About;


// WEBPACK FOOTER //
// ./src/containers/About/index.jsx